import { render, staticRenderFns } from "./simpleTextLayerDrawerB.vue?vue&type=template&id=dbc4698e&"
import script from "./simpleTextLayerDrawerB.vue?vue&type=script&lang=ts&"
export * from "./simpleTextLayerDrawerB.vue?vue&type=script&lang=ts&"
import style0 from "./simpleTextLayerDrawerB.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports